import React, { forwardRef, ReactElement, useEffect, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ISubHeaderProps } from '../SubHeader/SubHeader';
import { IPageProps } from '../Page/Page';
import { useSelector } from 'react-redux';
import { RootState } from 'stores/store';
import { authMenu } from 'menu';

interface IPageWrapperProps {
	isProtected?: boolean;
	title?: string;
	description?: string;
	children:
		| ReactElement<ISubHeaderProps>[]
		| ReactElement<IPageProps>
		| ReactElement<IPageProps>[];
	className?: string;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
	({ isProtected = true, title, description, className, children }, ref) => {
		useLayoutEffect(() => {
			// @ts-ignore
			document.getElementsByTagName('TITLE')[0].text = `${title ? `${title} | ` : ''}${
				process.env.REACT_APP_SITE_NAME
			}`;
			// @ts-ignore
			document
				?.querySelector('meta[name="description"]')
				.setAttribute('content', description || process.env.REACT_APP_META_DESC || '');
		});

		const loggedIn = useSelector((state: RootState) => state.auth.isLogged);

		const navigate = useNavigate();

		useEffect(() => {
			const unprotectedPaths = [
				authMenu.login.path,
				authMenu.joinTeam.path,
				authMenu.confirmLogin.path,
				authMenu.forgetGroup.subMenu.confirmation.path,
				authMenu.forgetGroup.subMenu.forgetPassword.path,
				authMenu.forgetGroup.subMenu.resetPassword.path,
			];
			const currentPath = window.location.pathname;
			const isUnprotected = unprotectedPaths.some(
				(path) => currentPath === path || currentPath.startsWith(`${path}/`),
			);
			if (isProtected && !loggedIn && !isUnprotected) {
				navigate(`../${authMenu.login.path}`);
			}
			return () => {};
		}, [isProtected, loggedIn, navigate]);

		return (
			<div ref={ref} className={classNames('page-wrapper', 'container-fluid', className)}>
				{children}
			</div>
		);
	},
);
PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
